import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"
import React, { useEffect } from "react"
import Lenis from "@studio-freight/lenis"

export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        const elements = document.querySelectorAll(".fadeInUp");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on");
                    }
                });
            },
            { threshold: 0.1 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }
};

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js");
  }
};




const WrapWithLenis = ({ element }) => {
    useEffect(() => {
        if (typeof window !== "undefined") {
            const lenis = new Lenis({
                duration: 1.2, // 慣性スクロールの強さ
                smooth: true,
            })

            function raf(time) {
                lenis.raf(time)
                requestAnimationFrame(raf)
            }
            requestAnimationFrame(raf)

            return () => {
                lenis.destroy()
            }
        }
    }, [])

    return <>{element}</>
}

export const wrapPageElement = ({ element }) => {
    return <WrapWithLenis element={element} />
}